import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { MantineProvider, createTheme, Button, Center, Stack, Title, Text, Group } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import AdminDashboard from './components/AdminDashboard';
import ClientChatPage from './components/ClientChatPage';
import SuperAdminDashboard from './components/SuperAdminDashboard';
import LoginPage from './components/LoginPage';

const theme = createTheme({
  primaryColor: 'violet',
  defaultRadius: 'md',
  fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif",
  headings: {
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif",
    fontWeight: '700',
  },
  colors: {
    violet: [
      '#f5f3ff','#ede9ff','#d8d0ff','#c4b8ff','#b8b8ff',
      '#9381ff','#7b66e6','#6650cc','#5240b3','#3e3099',
    ],
  },
});

function Home() {
  return (
    <Center style={{
      minHeight:'100vh',
      background:'#f5f3ff',
    }}>
      <Stack align="center" gap="xl" style={{
        background: '#ffffff',
        border: '1px solid #e8e5f0',
        borderRadius: '24px',
        padding: '48px 40px',
        boxShadow: '0 4px 24px rgba(147,129,255,0.08)',
      }}>
        <Title order={1} c="#2d2d2d" style={{fontSize:'2.4rem'}}>Chat Support System</Title>
        <Text c="#666666" size="lg" ta="center" maw={420} style={{fontWeight:400}}>
          A real-time helpdesk solution connecting users with support agents.
        </Text>
        <Button component={Link} to="/login" size="lg" radius="xl"
          variant="filled" color="violet">
          Login
        </Button>
        <Button component={Link} to="/client" size="lg" radius="xl"
            variant="light" color="violet">
          Client Chat
        </Button>
      </Stack>
    </Center>
  );
}

export default function App() {
  return (
    <MantineProvider theme={theme} defaultColorScheme="light">
      <Notifications position="bottom-center" autoClose={3000} />
      <Router>
        <Routes>
          <Route path="/"      element={<Home />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/helpdesk" element={<AdminDashboard />} />
          <Route path="/client" element={<ClientChatPage />} />
          <Route path="/superadmin" element={<SuperAdminDashboard role="super_admin" />} />
          <Route path="/manager" element={<SuperAdminDashboard role="manager" />} />
          <Route path="/supervisor" element={<SuperAdminDashboard role="supervisor" />} />
        </Routes>
      </Router>
    </MantineProvider>
  );
}
